export enum AgencyUsageType {
  MeetingTime = 'meeting_time',
  AgenticInterviews = 'agentic_interviews'
}

export const getAgencyUsageLabel = (type: AgencyUsageType): string => {
  switch (type) {
    case AgencyUsageType.MeetingTime:
      return 'Copilot Meeting Time';
    case AgencyUsageType.AgenticInterviews:
      return 'Agentic Interviews (sent)';
    default:
      return type;
  }
};

export const getAgencyUsageUnit = (type: AgencyUsageType): string => {
  switch (type) {
    case AgencyUsageType.MeetingTime:
      return 'min';
    case AgencyUsageType.AgenticInterviews:
      return 'interviews';
    default:
      return type;
  }
};
